import { render, staticRenderFns } from "./BvaNoticeCreate.vue?vue&type=template&id=1f626910&scoped=true&"
import script from "./BvaNoticeCreate.vue?vue&type=script&lang=ts&"
export * from "./BvaNoticeCreate.vue?vue&type=script&lang=ts&"
import style0 from "./BvaNoticeCreate.vue?vue&type=style&index=0&id=1f626910&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f626910",
  null
  
)

export default component.exports